import { useLocalStorage } from '@vueuse/core';
import { computed } from 'vue';
import { useRouteQuery } from '@/composables/useRouteQuery';
import { store } from '@/plugins/store';

const PAGE_SIZE_OPTIONS = [10, 20, 30, 40, 50];
const DEFAULT_PAGE_SIZE = PAGE_SIZE_OPTIONS[0];

export function useRecordsSearchParams() {
    const storedPageSize = useLocalStorage<number>('records:table-page-size', DEFAULT_PAGE_SIZE);

    // Ensure storedPageSize is valid, reset to default if not
    if (!PAGE_SIZE_OPTIONS.includes(storedPageSize.value)) {
        storedPageSize.value = DEFAULT_PAGE_SIZE;
    }

    const types = useRouteQuery<string | undefined>('types', undefined, {
        transform: (value) => value?.split(',').join(',') || undefined,
    });
    const page = useRouteQuery<number>('page', 1, { transform: Number });

    const computedPageSize = computed({
        get() {
            return storedPageSize.value;
        },
        set(value) {
            if (PAGE_SIZE_OPTIONS.includes(value)) {
                storedPageSize.value = value;
            }
        },
    });

    const computedTypes = computed({
        get() {
            return types.value?.split(',').map(Number) || [];
        },
        set(value: number[]) {
            types.value = value.length > 0 ? value.join(',') : undefined;
        },
    });

    const fetchParams = computed(() => ({
        page: page.value,
        pageSize: computedPageSize.value,
        typeIds: computedTypes.value,
        period: store.getters.getSelectedPeriod,
        siteIds: store.getters.getSelectedSiteIds,
    }));

    return {
        page,
        pageSize: computedPageSize,
        fetchParams,
        pageSizeOptions: PAGE_SIZE_OPTIONS,
        types: computedTypes,
    };
}
